

































































































import UserApi from "@/api/userApi";

import { Component, Prop, Vue } from "vue-property-decorator";
// import { namespace } from "vuex-class";
import QNotify from "@/common/qNotify";
// const userStore = namespace("User");

@Component({
  name: "UserEdit",
})
export default class UserEdit extends Vue {
  @Prop({
    default: function () {
      return {
        id: "",
        login_id: "",
        password: "",
        name: "",
      };
    },
  })
  editData;

  public errors = [];
  public isShow = false;

  public clearErrors() {
    this.errors = [];
  }

  public handleChangePassword(event) {
    if (event.target.value.includes("•")) {
      this.editData.password = event.data;
    }
  }

  public confirmDelete(): void {
    this.$modal.showDelete({
      confirmClass: "mb__add-color-red",
      text: `${this.editData.name} を削除します。この操作は取り消せません。`,
      onConfirm: () => {
        this.deleteUser();
      },
    });
  }

  public confirmCancel(): void {
    this.$modal.showCancel({
      text: `${this.editData.name}${this.$t("common.cancel_message")}`,
      confirmText: `${this.$t("common.message.cancel_button")}`,
      onConfirm: () => {
        this.isShow = false;
      },
    });
  }

  public statusError(field) {
    return this.errors[field] ? "error" : "";
  }

  public clearError(field) {
    this.errors[field] = "";
    this.$forceUpdate();
  }

  public prepareEditData() {
    if (this.editData.password === "••••••••") {
      this.editData.password = "";
    }
  }

  async submit(): Promise<void> {
    this.prepareEditData();
    try {
      await UserApi.add(this.editData).then((response) => {
        if (response.data.message == "success") {
          this.isShow = false;
          this.reloadUserList();
        } else if (response.data.message == "error") {
          let result = response.data.result;
          for (let field in result) {
            let error = result[field];
            for (let key in error) {
              this.errors[field] = error[key];
            }
          }

          this.$forceUpdate();
        } else {
          QNotify.error({
            text: response.data.message,
          });
        }
      });
    } catch (error) {
      console.log(error);
    }
  }

  public deleteUser() {
    UserApi.delete(this.editData.id)
      .then((response) => {
        if (response.data.message == "success") {
          this.isShow = false;
          this.reloadUserList();
        } else {
          QNotify.error({
            text: response.data.message,
          });
        }
      })
      .catch((error) => {
        if (error.response.status === 404) {
          this.isShow = false;
          QNotify.error({
            text: "該当データは既に削除されています。",
          });
          this.reloadUserList();
        }
      });
  }

  public reloadUserList() {
    this.$root.$emit("fetchUserList", this.$route.query);
  }
}
